import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { FilterYearMonthType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelWaitCat } from "../../functions/Report.ExportWaitCat";
import { formatTimeWaitCat } from "../../utils/Report.Format";
import { BARCHART, FLEXDROPDOWN, STYLEBODY } from "../../../../utils/useStyle";

const ReportTimePaperToCatheter = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [month, setMonth] = React.useState({
    label: "ทุกเดือน",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = React.useState({
    Zero: 0,
    A: 0,
    B: 0,
    C: 0,
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getTimePaperToCatheterReport({
          year: String(year?.value),
          type: String(type?.value),
          month: String(month?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching time paper to catheter report:", error);
      }
    };
    fetchData();
  }, [year, type, month, userDept]);

  const total =
    (data?.Zero || 0) + (data?.A || 0) + (data?.B || 0) + (data?.C || 0);

  const listTable = [
    { name: "0 วัน", count: data?.Zero || 0 },
    { name: "1-2 วัน", count: data?.A || 0 },
    { name: "3-5 วัน", count: data?.B || 0 },
    { name: "6 วันขึ้นไป", count: data?.C || 0 },
  ];

  const renderCustomLabel = (props) => {
    const { x, y, width, height, value } = props;
    const percentage = ((value / total) * 100).toFixed(1) + "%";
    const insideBarPosition = y + height / 2;

    return (
      <g>
        <text
          x={x + width / 2}
          y={insideBarPosition}
          fill="#111827"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {`${value} (${percentage})`}
        </text>
      </g>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`${label} : ${payload[0].value} `}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <div className={``}>
        <div className="my-20">
          <>
            <div className="flex flex-col gap-4">
              <div className="text-black text-lg font-medium">
                ระยะเวลาตั้งแต่ที่ได้รับใบปรึกษา
                จนกระทั่งผู้ป่วยได้รับการใส่สายน้ำเกลือ
                <div className={STYLEBODY}>
                  ของปี "{year.label}" ตามประเภทสาย "{type.label}"
                </div>
              </div>
              <div className={FLEXDROPDOWN}>
                <FilterYearMonthType
                  year={year}
                  setYear={setYear}
                  type={type}
                  setType={setType}
                  month={month}
                  setMonth={setMonth}
                />

                <ButtonExcel
                  text={"DOWNLOAD EXCEL"}
                  onClick={() => {
                    ExcelWaitCat(
                      formatTimeWaitCat(data),
                      year,
                      type,
                      setLoading,
                      month
                    );
                  }}
                  loading={loading}
                />
              </div>
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listTable}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={CustomTooltip} />
                <Bar dataKey="count" fill="#99CC00" label={renderCustomLabel} />
              </BarChart>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default ReportTimePaperToCatheter;
